import { LanguageEnum } from 'enums'

export enum LANGUAGES {
  TH = 'th',
  EN = 'en',
}

export const getLangIDbyLineLang = (lineLang) => {
  let selectedLang = ''
  if (/^en\b/.test(lineLang)) {
    selectedLang = LANGUAGES.EN
  } else if (/^th\b/.test(lineLang)) {
    selectedLang = LANGUAGES.TH
  }

  return selectedLang
}

export const languagesSystemSupport = {
  en: {
    value: LanguageEnum.en,
    label: 'hatoheart.editMember.engLabel',
    flag: '/assets/languages/flag-england.png',
  },
  th: {
    value: LanguageEnum.th,
    label: 'hatoheart.editMember.thaiLabel',
    flag: '/assets/languages/flat-th.png',
  },
}
